import { environment } from '@environments/environment';

/**
 * State for the month selector bar component
 *
 * @export
 * @class State
 */
export class State {
	loading: boolean;
	startingDate: Date;
	selectedMonth: string;
}

export const initialState: State = {
	loading: false,
	startingDate: new Date(),
	selectedMonth: initialMonthValue() + ' ' + initialYearValue()
};

function initialMonthValue() {
	const date = new Date();
	const options = { month: 'short' };
	return date.toLocaleDateString(environment.locale, options);
}

function initialYearValue() {
	const date = new Date();
	const options = { year: '2-digit' };
	return date.toLocaleDateString(environment.locale, options);
}
